import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';

import { WhatsappStatusDto } from './dto/whatsapp-status.dto';

@Injectable({
  providedIn: 'root',
})
export class StatusSistemaAtendimentoService {
  private readonly _statusWhatsapp = new BehaviorSubject<WhatsappStatusDto | null>(null);

  constructor(private readonly _httpClient: HttpClient) {}

  get statusWhatsapp$(): Observable<WhatsappStatusDto | null> {
    return this._statusWhatsapp.asObservable();
  }

  getStatusWhatsapp(): Observable<WhatsappStatusDto | null> {
    return this._httpClient
      .get<WhatsappStatusDto>(`${environment.api}/whatsapp/whatsapp-status`)
      .pipe(
        tap((statusWhatsapp) => this._statusWhatsapp.next(statusWhatsapp)),
        catchError(() => {
          this._statusWhatsapp.next(null);
          return of(null);
        })
      );
  }
}
